import { Logger } from '@vue-storefront/core/lib/logger'

/**
 * Minimal GTM shim – the actual GTM loader script is injected server-side in
 * the HTML template (index.template.html). This hook only exposes `this.$gtm`
 * and `Vue.gtm` as thin wrappers around `window.dataLayer.push()` so that all
 * existing call-sites (`this.$gtm.trackEvent(...)`) keep working unchanged.
 */
function ensureDataLayer (): any[] {
  if (typeof window === 'undefined') return []
  const w = window as any
  if (!Array.isArray(w.dataLayer)) {
    w.dataLayer = []
  }
  return w.dataLayer
}

const gtmShim = {
  trackEvent (data: Record<string, any> = {}) {
    const dataLayer = ensureDataLayer()
    dataLayer.push(data)
  },
}

export function beforeRegistration ({ Vue, config, isServer }) {
  if (config.googleTagManager.active) {
    Vue.gtm = gtmShim
    Vue.prototype.$gtm = gtmShim
  } else {
    Logger.warn('Google Tag Manager extensions is not working', 'GTM')()
  }
}
